import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import Axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LS_LANGUAGE } from '../../constants';
import * as ActionCreators from '../../redux/action';
import Moment from 'react-moment';
import flatten from 'flat';

import messages_en from '../../translations/en_default.json';
import messages_sk from '../../translations/sk.json';

const DEFAULT_MESSAGES = {
  en: messages_en,
  sk: messages_sk,
};

/**
 * Component to fetch translations for app and wrap app in provider
 * @param {*} param0
 */
function IntlLayout({ children, appLanguage, setAppLanguage }) {
  const [translations, setTranslations] = useState(DEFAULT_MESSAGES);

  useEffect(() => {
    Axios.get(`${process.env.REACT_APP_TRANSLATIONS_URL}/sk/translations/member-area`)
      .then((res) =>
        setTranslations((old) => ({
          ...old,
          sk: {
            ...old.sk,
            ...flatten(res.data, {
              delimiter: '_',
            }),
          },
        }))
      )
      .catch((error) => {
        console.log('TRANSLATION LOADING ERROR', error);
      });
  }, []);

  useEffect(() => {
    if (localStorage.getItem(LS_LANGUAGE) !== null) {
      const savedLanguage = localStorage.getItem(LS_LANGUAGE);
      setAppLanguage(savedLanguage);
    }
    Moment.globalLocale = appLanguage;
  }, [appLanguage, setAppLanguage]);

  return (
    <IntlProvider defaultLocale="sk" locale={appLanguage} messages={translations[appLanguage]}>
      {children}
    </IntlProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    appLanguage: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setAppLanguage: ActionCreators.setAppLanguage,
    },
    dispatch
  );
};

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(IntlLayout));
